import { render, staticRenderFns } from "./MaterielDetail.vue?vue&type=template&id=77e25a2d"
import script from "./MaterielDetail.vue?vue&type=script&lang=js"
export * from "./MaterielDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports